"use client";

import { useEffect } from "react";
import { useShouldShowAds } from "./ads/AdsProvider";
import { hasAdsRuntime } from "@/lib/ads/policy";

export default function AdsScript() {
  const shouldShowAds = useShouldShowAds();
  useEffect(() => {
    if (!shouldShowAds || hasAdsRuntime(document)) return;
    const script = document.createElement("script");
    script.id = "google-adsense";
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9143210451390429";
    document.head.appendChild(script);
    // Keep the marker: removing a script cannot undo its executed runtime.
    // AdsNavigationGuard resets that runtime when entering the dashboard.
  }, [shouldShowAds]);
  return null;
}
